import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Text } from 'blaze-ui/Text/Text'

export const NoAccountsContent = ({ provider }: { provider: ExternalIntegrationEnum }) => {
  if (provider === ExternalIntegrationEnum.Instagram) {
    return (
      <div>
        <Text>We couldn't find any Instagram Business or Creator accounts associated with the pages you manage.</Text>
        <br />
        <br />
        <Text>
          If you have an Instagram Business or Creator account that you would like to connect, please make sure that it
          is associated with a Facebook page and that you selected that Facebook page when granting Blaze permission to
          use your Meta Business assets. If you're unsure which specific Facebook page is associated with your Instagram
          account, you can choose to 'Select all' pages when granting permissions.
        </Text>
      </div>
    )
  }

  if (provider === ExternalIntegrationEnum.Facebook) {
    return (
      <div>
        <Text>We couldn't find any Facebook Pages associated with your account.</Text>
        <br />
        <br />
        <Text>
          Please make sure you gave Blaze permission to the correct pages and that you are an admin of the pages you are
          trying to connect.
        </Text>
      </div>
    )
  }

  if (provider === ExternalIntegrationEnum.YouTube) {
    return (
      <div>
        <Text>No YouTube channels associated with this account.</Text>
        <br />
        <br />
        <Text>
          Please make sure you have a YouTube channel and that you granted Blaze the necessary permissions to access it.
        </Text>
      </div>
    )
  }

  return (
    <Text>We weren't able to find any accounts. Please make sure you granted the correct permissions to Blaze.</Text>
  )
}
